import {useGradientMaterial}          from '@/components/global/UseGradientMaterial'
import {ZibenCanvas}                  from '@/components/global/ZibenCanvas'
import {Plane}                        from '@react-three/drei'
import {useThree}                     from '@react-three/fiber'
import cn                             from 'classnames'
import {useRef}                       from 'react'
import {AdditiveBlending, DoubleSide} from 'three'
import styles                         from './GradientCanvas.module.sass'

const CanvasContent = ({hovering}) => {
	// region References
	const plane = useRef()
	// endregion

	// Make plane full screen
	const {gl} = useThree()
	plane.current?.scale.set(gl._width, gl._height, 1)

	const {
		      key,
		      colorNode,
	      } = useGradientMaterial({hovering})

	return (<Plane
		ref={plane}
		args={[
			10, 10, 10,
		]}
	>
		<meshBasicNodeMaterial
			key={key}
			colorNode={colorNode}
			blend={AdditiveBlending}
			side={DoubleSide}
		/>
	</Plane>)
}

const GradientCanvas = ({
	hovering,
	className,
	onMouseEnter = () => {
	},
	onMouseLeave = () => {
	},
}) => {
	return (<div
		onMouseEnter={onMouseEnter}
		onMouseLeave={onMouseLeave}
		className={cn(styles.gradient_canvas, className)}
	>
		<ZibenCanvas>
			{/* <WebGPUPostProcessing
				 strength={0.25}
				 radius={0.1}
				 quality={'default'}
				 /> */}

			<CanvasContent hovering={hovering}/>
		</ZibenCanvas>
	</div>)
}
export default GradientCanvas
